function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.67578 10.1732C1.67578 7.09852 1.67578 5.56076 2.63138 4.60598C3.58697 3.65121 5.12391 3.65039 8.19861 3.65039H11.46C14.5347 3.65039 16.0725 3.65039 17.0273 4.60598C17.982 5.56158 17.9829 7.09852 17.9829 10.1732V11.8039C17.9829 14.8786 17.9829 16.4164 17.0273 17.3712C16.0717 18.3259 14.5347 18.3268 11.46 18.3268H8.19861C5.12391 18.3268 3.58615 18.3268 2.63138 17.3712C1.6766 16.4156 1.67578 14.8786 1.67578 11.8039V10.1732Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.22303
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75112 3.65076V2.42773M13.9047 3.65076V2.42773M2.08203 7.72753H17.5737",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.22303,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.46267e9b951fd4743a74fe0ed15b9dd8.svg";
export { ForwardRef as ReactComponent };